export const mailtoContact = 'mailto:hello@pbjapps.com'
